query AvailableWorkgroupUsers {
  availableWorkgroupUsers(orderBy: NAME_ASC) {
    nodes
     {
        id
        name
        emailAccount
        _signinInfo
        {
            profileIconType
            profileIconState

        }
        _lastUsedDate
     }
      }
  }